import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import SideMenu from './SideMenu';
import EntityView from './pages/EntityView/EntityView';

const sideMenuRoute = () => {
  const isEntityViewOnly = typeof window !== "undefined" && window.location.pathname.includes("/entityview");

  return (
    <BrowserRouter>
      {isEntityViewOnly ? <EntityView /> : <SideMenu/>}
    </BrowserRouter>
  );
};

export default sideMenuRoute;
